import React from "react";
import { Link } from "react-router-dom";
import { CarouselStyles } from "styles/style";
import { utils } from "supabase/content/utils.ts";


export const VideoCard = ({ video, idx, table = "service" }) => {
  console.log("video: ", video)
  const thumbnail = video.thumbnail ? `https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/${video.thumbnail}.jpg` : null;
  return (
    <CarouselStyles.VideoCardContainer>
      <CarouselStyles.MobileCard
        as={Link}
        to={`./${video.id ?? utils.formattedDate(video.date)}`}
      >
        <CarouselStyles.MobileThumbWrapper>
          <CarouselStyles.MobileThumb src={thumbnail} alt={video.date} />
        </CarouselStyles.MobileThumbWrapper>
        <div tw="flex flex-col justify-between">
          <CarouselStyles.VideoCardTitle>{video.title}</CarouselStyles.VideoCardTitle>
        </div>
      </CarouselStyles.MobileCard>

      {/* Desktop Layout */}
      <CarouselStyles.DesktopCard
        as={Link}
        to={`./${video.id ?? utils.formattedDate(video.date)}`}
      >
        <CarouselStyles.VideoPlayer>
          <CarouselStyles.MobileThumb src={thumbnail} alt={video.date} />
        </CarouselStyles.VideoPlayer>

        <CarouselStyles.CardContentContainer>
          <CarouselStyles.VideoCardTitle>{video.title}</CarouselStyles.VideoCardTitle>
        </CarouselStyles.CardContentContainer>
      </CarouselStyles.DesktopCard>
    </CarouselStyles.VideoCardContainer>
  )
}